import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable } from 'rxjs';

/**
 * UI loader service
 *
 * @export
 * @class LoaderService
 */
@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  /**
   * Subject for UI loader visibility.
   */
  public _display$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  static readonly COUNT_DOWN_TIME_SECONDS = 30;
  private countDownTime = LoaderService.COUNT_DOWN_TIME_SECONDS;
  private countDownTimer$ = interval(1000);
  /**
   * Visibility value to be emitted.
   */
  private _isDisplay = false;

  constructor() {
    this.countDownTimer$.subscribe({
      next: () => {
        if (this.countDownTime > 0) {
          this.countDownTime--;
          if (this.countDownTime === 0) {
            this.hide();
          }
        }
      },
    });
  }

  /**
   * Get UI loader visibility subject as observable type,
   *
   * @return {*}  {Observable<boolean>}
   * @memberof LoaderService
   */
  getSideMenuObservable(): Observable<boolean> {
    return this._display$.asObservable();
  }

  /**
   * Show UI loader.
   *
   * @memberof LoaderService
   */
  show(): void {
    this.resetCountDown();
    if (this._isDisplay === false) {
      this._isDisplay = true;
      this._display$.next(this._isDisplay);
    }
  }

  /**
   * Hide UI loader.
   *
   * @memberof LoaderService
   */
  hide(): void {
    this.countDownTime = 0;
    if (this._isDisplay) {
      this._isDisplay = false;
      this._display$.next(this._isDisplay);
    }
  }
  resetCountDown(): void {
    this.countDownTime = LoaderService.COUNT_DOWN_TIME_SECONDS;
  }
}
